// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__12l_e","validationTips":"StatementDescriptor_validationTips__3rQ8a"};